import io from "socket.io-client";

export const socket = io().close();

export enum SocketEvents {
  connect = "connect",
}
